import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import { AnalyticsEvent } from './AnalyticsEvent';
import { Visitor } from './Visitor';

@supertypeClass({ toClient: true, toServer: true })
export class AnalyticsContainer extends Everything {
  @property()
  ipAddress: string;

  @property({ type: Array, getType: () => AnalyticsEvent })
  analyticsEvents: Array<AnalyticsEvent> = [];

  @property()
  userAgent: string;

  @property()
  referrer: string;

  @property()
  firstEventTime: Date;

  @property()
  lastEventTime: Date;

  @property()
  page: string;

  @property()
  scrollDepth: number;

  @property()
  scrollHistory: string;

  @property()
  mouseMoveHistory: string;

  @property({ getType: () => Visitor })
  visitor: Visitor;

  constructor() {
    super();
  }

  static new(visitor, userAgent, referrer) {
    return new AnalyticsContainer().init(visitor, userAgent, referrer);
  }

  init(visitor, userAgent, referrer) {
    this.visitor = visitor;
    this.userAgent = userAgent;
    this.referrer = referrer;
    this.firstEventTime = new Date();
    this.lastEventTime = new Date();
    return this;
  }

  setTimeByEvent(start, end) {
    if (start && (!this.firstEventTime || start.getTime() < this.firstEventTime.getTime())) {
      this.firstEventTime = start;
    }
    if (end && (!this.lastEventTime || end.getTime() > this.lastEventTime.getTime())) {
      this.lastEventTime = end;
    }
  }

  addEvent(props) {
    const event = AnalyticsEvent.new(props);

    this.analyticsEvents.push(event);
    this.setTimeByEvent(event.startTime, event.endTime);

    if (this.visitor) {
      this.visitor.setTimeByEvent(event.startTime, event.endTime);
    }
  }

  setVisitor(visitor) {
    this.visitor = visitor;

    this.analyticsEvents.forEach(
      function (event) {
        this.visitor.setTimeByEvent(event.startTime, event.endTime);
      }.bind(this)
    );
  }
}
